import { RegexOption } from 'src/shared/constants/regex-formats/types/RegexTypes';

export const currencyRegexOptions: RegexOption[] = [
  {
    type: 'currency-usd',
    display: 'USD $X.XX',
    code: '$X.XX',
    icon: 'DollarSign',
    regex: '^\\$\\d{1,3}(?:,\\d{3})*(?:\\.\\d{2})?$',
    examples: ['$0.00', '$1.50', '$1,234.56', '$1,000,000.00'],
  },
  {
    type: 'currency-eur-symbol',
    display: 'EUR €X,XX',
    code: '€X,XX',
    icon: 'Euro',
    regex: '^€\\d{1,3}(?:\\.\\d{3})*(?:,\\d{2})?$',
    examples: ['€0,00', '€1,50', '€1.234,56', '€1.000.000,00'],
  },
  {
    type: 'currency-gbp',
    display: 'GBP £X.XX',
    code: '£X.XX',
    icon: 'PoundSterling',
    regex: '^£\\d{1,3}(?:,\\d{3})*(?:\\.\\d{2})?$',
    examples: ['£0.00', '£1.50', '£1,234.56', '£1,000,000.00'],
  },
  {
    type: 'currency-jpy',
    display: 'JPY ¥X',
    code: '¥X',
    icon: 'JapaneseYen',
    regex: '^¥\\d{1,3}(?:,\\d{3})*$',
    examples: ['¥0', '¥150', '¥1,234', '¥1,000,000'],
  },
  {
    type: 'currency-inr',
    display: 'INR ₹X.XX',
    code: '₹X.XX',
    icon: 'IndianRupee',
    regex: '^₹\\d{1,3}(?:,\\d{2}(?:,\\d{2})*)?(?:\\.\\d{2})?$',
    examples: ['₹0.00', '₹1.50', '₹1,234.56', '₹1,00,000.00'],
  },
  {
    type: 'currency-range',
    display: 'Range $X.XX - $Y.YY',
    code: '$X.XX - $Y.YY',
    icon: 'DollarSign',
    regex: '^\\$\\d{1,3}(?:,\\d{3})*(?:\\.\\d{2})?\\s-\\s\\$\\d{1,3}(?:,\\d{3})*(?:\\.\\d{2})?$',
    examples: ['$0.00 - $1.00', '$1.50 - $2.50', '$1,000.00 - $2,000.00'],
  },
  {
    type: 'currency-negative',
    display: '-$X.XX',
    code: '-$X.XX',
    icon: 'DollarSign',
    regex: '^-\\$\\d{1,3}(?:,\\d{3})*(?:\\.\\d{2})?$',
    examples: ['-$0.00', '-$1.50', '-$1,234.56', '-$1,000,000.00'],
  },
];
